import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { AuthService } from './auth.service';

/** Anexa o token (tenant ou plataforma conforme a rota) + X-Correlation-Id; trata 401. */
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  const isPlatform = req.url.includes('/api/platform');
  const isTenant = req.url.includes('/api/t/');
  const isAuthCall = req.url.includes('/auth/');

  let headers = req.headers.set('X-Correlation-Id', crypto.randomUUID());
  // Chamadas de autenticação (login, aceite de convite) vão sempre sem token: uma sessão de
  // outra empresa ainda no browser faria o backend recusar o pedido com 403.
  const token = isAuthCall ? null : isPlatform ? auth.platformToken() : isTenant ? auth.tenantToken() : null;
  if (token) {
    headers = headers.set('Authorization', `Bearer ${token}`);
  }

  return next(req.clone({ headers })).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401 && !isAuthCall) {
        if (isPlatform) {
          auth.logoutPlatform();
        } else if (isTenant) {
          auth.logoutTenant();
        }
        if (isPlatform || isTenant) {
          // A sessão acabou a meio do trabalho: depois de entrar, volta-se ao mesmo sítio.
          // Vários pedidos falham juntos com o mesmo 401: só o primeiro leva ao login.
          if (!router.url.startsWith('/login')) {
            router.navigate(['/login'], { queryParams: isTenant ? { returnUrl: router.url } : {} });
          }
        }
      }
      return throwError(() => error);
    }),
  );
};
